export default function DateController() {
    /////////////////////
    //
    //      Direct variables
    //
    /////////////////////

    var vm = this;
}
